import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Account from "./pages/Account";
import AuthCallback from "./pages/AuthCallback";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import { PastorAuthProvider } from "./lib/pastorAuth";
import "./App.css";

const TITLES = {
  "/": "Digital Missions | Free Websites & Marketing for Churches",
  "/admin": "Mission Control · Digital Missions",
  "/account": "My Applications · Digital Missions",
  "/payment/success": "Thank You · Digital Missions",
  "/payment/cancel": "Gift Cancelled · Digital Missions",
};

const AppRouter = () => {
  const location = useLocation();
  useEffect(() => { document.title = TITLES[location.pathname] || "Digital Missions"; }, [location.pathname]);
  // Google OAuth returns to {origin}/account#session_id=... — exchange it before any route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/account" element={<Account />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" />
      <Toaster position="top-right" richColors theme="dark" />
      <BrowserRouter>
        <PastorAuthProvider>
          <AppRouter />
        </PastorAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
